module.exports = __webpack_public_path__ + "static/img/wiseBrainIcon4.b649333.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wiseBrainIcon4.png
// module id = ++8v
// module chunks = 1